

import React from 'react';

import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const TestMessagingHelp = () => (
  <>
    <h1>Test Messaging</h1>
    <p>
      The “Test Messaging” page can be used to send test alert messages for a
      sample set of commonly applied message types. The sent message will be
      formatted based on your account’s Email Configuration settings for the
      specified Trip Group.
    </p>
    <ul>
      <li>
        <i>
          Note: These email messages are for display purposes only. Any links
          provided in the sample email messages are invalid and if clicked will
          return an error.
        </i>
      </li>
    </ul>
    <p>
      <strong>Trip Group:</strong> Select “Default” to receive an alert using
      the default configuration for your account. To see a sample email from a
      Trip Group that has custom messaging enabled, select the specific Trip
      Group from the dropdown menu.
    </p>
    <p>
      <strong>Email:</strong> Enter the email address where you’d like the
      sample email message to be delivered.
    </p>
    <p>
      <strong>Sample Message Type:</strong> Select the sample email messag e
      you’d like to receive.
    </p>
    <ul>
      <li>
        <strong>Opt In:</strong> This is a sample Opt-in invitation email a
        traveler would receive to Opt-in and create a Trip Alert Profile for
        messaging or Opt-out of future invitations.
      </li>
      <li>
        <strong>Trip Reminder:</strong> Sample email message the traveler would
        receive regarding their upcoming trip. This message includes information
        about the departure of the first flight of each leg, providing check-in
        link for operating carrier, terms of carriage, and flight status info of
        their upcoming trip.
      </li>
      <li>
        <strong>Connection Information:</strong> This message is sent to the
        traveler to notify them of their connection. This alert will include the
        estimated connection time, flight status information, and gate/terminal
        information if available.
      </li>
      <li>
        <strong>Cancellation:</strong> Sample email message that would be sent
        to the traveler should any flight on the trip is reported as cancelled.
      </li>
      <li>
        <strong>Gate Change:</strong> Email message the traveler would receive
        when the departing flight’s gate is assigned or changed.
      </li>
      <li>
        <strong>Departure Delay:</strong> This message is sent to the traveler
        to notify them that their departing flight has a departure delay.
      </li>
      <li>
        <strong>Diversion:</strong> Sample email message that would be sent to
        the traveler should any flight on the trip is reported as diverted.
      </li>
      <li>
        <strong>Departure Information:</strong> Sample email message sent to the
        traveler as a status update for their upcoming trip.
      </li>
      <li>
        <strong>Waiver:</strong> Sample email message that would be sent to the
        traveler should any flight on the trip matches an exception waiver
        issued by a participating airline. Email will include the affected trip
        details, issuing airline, and waiver name.
      </li>
    </ul>
    <p>
      <strong>SEND TEST MESSAGE:</strong> Click the “SEND TEST MESSAGE” button
      when done. A “Successfully sent message to email@example.com.” will be
      displayed when finished.
    </p>
    <HelpPageFooterNotice />
  </>
);

export default TestMessagingHelp;
